import {
  type HTMLAttributes,
  type TdHTMLAttributes,
  type ThHTMLAttributes,
} from 'react';

function Root({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLTableElement>) {
  return (
    <div className="border-taupe-600 overflow-hidden rounded-xl border shadow-sm">
      <table
        className={`w-full border-collapse text-left ${className ?? ''}`}
        {...props}
      >
        {children}
      </table>
    </div>
  );
}

function Header({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLTableSectionElement>) {
  return (
    <thead className={`bg-taupe-200 ${className ?? ''}`} {...props}>
      <tr>{children}</tr>
    </thead>
  );
}

function HeaderCell({
  className,
  children,
  ...props
}: ThHTMLAttributes<HTMLTableCellElement>) {
  return (
    <th
      className={`border-taupe-600 text-taupe-800 border-b px-5 py-3.5 text-xs font-semibold tracking-wide uppercase ${className ?? ''}`}
      {...props}
    >
      {children}
    </th>
  );
}

function Body({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLTableSectionElement>) {
  return (
    <tbody
      className={`divide-taupe-550 bg-taupe-50 divide-y ${className ?? ''}`}
      {...props}
    >
      {children}
    </tbody>
  );
}

function Row({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLTableRowElement>) {
  return (
    <tr
      className={`hover:bg-taupe-200 transition-colors duration-150 ${className ?? ''}`}
      {...props}
    >
      {children}
    </tr>
  );
}

function Cell({
  className,
  children,
  ...props
}: TdHTMLAttributes<HTMLTableCellElement>) {
  return (
    <td
      className={`text-taupe-900 px-5 py-4 text-sm ${className ?? ''}`}
      {...props}
    >
      {children}
    </td>
  );
}

const TransactionsTable = Object.assign(Root, {
  Header,
  HeaderCell,
  Body,
  Row,
  Cell,
});

export default TransactionsTable;
